<form [formGroup]="Form" class="one-col" (ngSubmit)="send()">
  <h4 class="text-center vs-text-blue mb-4">
    {{data && data['id'] ? 'Edición ' : 'Creación '}} de {{data['modal'].item}}
  </h4>
  <div *ngIf="data['modal'].type === 3" class="vs-outline-editCard h-fit-content my-3 flex-column one-col">
    <div class="btn-custom-file h-100 w-100">
      <label for="file-pdf" class="custom-file-upload mt-4">
        <mat-icon>picture_as_pdf</mat-icon>
        <span class="my-2 text-center">{{data ? 'Editar ' : 'Agregar'}}
          PDF</span>
      </label>
      <input id="file-pdf" accept="application/pdf" type="file" (change)="file64($event)"/>
    </div>
    <div class="w-100 d-flex justify-content-center my-3">
      <mat-hint *ngIf="pdf">Archivo cargado:{{pdf}}</mat-hint>
    </div>
  </div>
  <a *ngIf="document && data['modal'].type === 3" class="vs-btn-blue vs-btn-outline mb-3" [href]="document"
     target="_blank">
    Ver PDF actual
  </a>
  <div [ngClass]="{'two-col': data['modal'].type === 2}" class="one-col">
    <mat-form-field *ngIf="data['modal'].type === 2" appearance="outline">
      <mat-label>Fecha de inicio</mat-label>
      <input id="pickerStart" matInput [matDatepicker]="pickerStart" formControlName="startDate">
      <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>
    <mat-form-field *ngIf="data['modal'].type === 2" appearance="outline">
      <mat-label>Fecha de fin</mat-label>
      <input id="pickerEnd" matInput [matDatepicker]="pickerEnd" formControlName="endDate">
      <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
  </div>
  <div *ngIf="data['modal'].type !== 4" [ngClass]="{'two-col': data['modal'].type === 1}" class="one-col">
    <mat-form-field appearance="outline">
      <mat-label>Nombre x</mat-label>
      <input formControlName="name" matInput autocomplete="off" placeholder="Ingresar nombre..." type="text">
    </mat-form-field>
    <mat-form-field *ngIf="data['modal'].type === 1 || data['modal'].type === 3" appearance="outline">
      <mat-label>Orden</mat-label>
      <input formControlName="orderId" matInput autocomplete="off" placeholder="Ingresar orden..." type="number">
      <mat-hint align="end">Ejemplo: 1,2,3...</mat-hint>
    </mat-form-field>
  </div>
  <div *ngIf="data['modal'].type === 2" class="one-col">
    <mat-form-field appearance="outline">
      <mat-label>Total de Operaciones en el mes</mat-label>
      <input formControlName="totalOperationsByMonth" matInput autocomplete="off" placeholder="Ingresar total..." type="number">
    </mat-form-field>
  </div>
  <!-- <ng-template [ngIf]="data['modal'].type === 4">
    <mat-form-field appearance="outline">
      <mat-label>Información</mat-label>
      <textarea formControlName="information" matInput autocomplete="off" placeholder="Ingresar información..." type="text"></textarea>
    </mat-form-field>
  </ng-template> -->
  <!-- class="col-12 px-xl-0 mb-4" -->
  <ng-template [ngIf]="data['modal'].type === 4" class="col-12 px-xl-0 mb-4">
    <label class="form-label text-dark">Información</label>
    <quill-editor placeholder="Ingresar información..." formControlName="information"
      [style]="{'height': '200px'}">
      <div quill-editor-toolbar class="w-100">
        <span class="ql-formats">
          <button class="ql-bold" [title]="'Bold'"></button>
          <button class="ql-italic" [title]="'Italic'"></button>
          <button class="ql-underline" [title]="'Subrayado'"></button>
          <button class="ql-strike" [title]="'Strike'"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-link" [title]="'Link'"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-align" [title]="'Justificación de texto'">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="bullet"></button>
        </span>
      </div>
    </quill-editor>
  </ng-template>


  <button type="submit" class="vs-btn-blue mt-2" [disabled]="Form.invalid">
    {{data && data['id'] ? 'Edición ' : 'Creación '}}
    de {{data['modal'].item}}
  </button>
</form>
